export enum DataObjectOverloadType { Symmetric, Lhs, Rhs }
